import { PureComponent, ReactNode } from "react";
import { FAQProps } from "@App/Components/common/FAQ";

export class ServiceCardInfo extends PureComponent<FAQProps> {
  render(): ReactNode {
    return (
      <div className={"bg-neutral-100 py-6 px-6 md:px-12 rounded-md"}>
        <div className="flex flex-col md:flex-row md:items-center">
          <svg
            className={"w-16 md:w-24 h-16 fill-primary mr-8 mb-4 md:mb-0"}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
          >
            <path d="M352 352h128c8.836 0 16-7.164 16-16S488.8 320 480 320h-128c-8.836 0-16 7.164-16 16S343.2 352 352 352zM512 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96C576 60.65 547.3 32 512 32zM544 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V128h512V416zM32 96c0-17.64 14.36-32 32-32h448c17.64 0 32 14.36 32 32H32zM352 224h128c8.836 0 16-7.164 16-16S488.8 192 480 192h-128c-8.836 0-16 7.164-16 16S343.2 224 352 224zM352 288h128c8.836 0 16-7.164 16-16S488.8 256 480 256h-128c-8.836 0-16 7.164-16 16S343.2 288 352 288zM192 288c35.35 0 64-28.65 64-64S227.3 160 192 160S128 188.7 128 224S156.7 288 192 288zM192 192c17.64 0 32 14.36 32 32S209.6 256 192 256S160 241.6 160 224S174.4 192 192 192zM96 416c8.836 0 16-7.164 16-16C112 373.5 133.5 352 160 352h64c26.51 0 48 21.49 48 48c0 8.836 7.164 16 16 16s16-7.164 16-16c0-44.18-35.82-80-80-80H160c-44.18 0-80 35.82-80 80C80 408.8 87.16 416 96 416z" />
          </svg>
          <div>
            <p className={"mb-3"}>
              Bitte halten Sie beim Servicetermin Ihre Ayvens Tank- oder{" "}
              <br className={"hidden md:inline"} /> Servicekarte zur Vorlage bei der Werkstatt
              bereit.
            </p>
            <p>
              Diese berechtigt Sie zur Beauftragung der Reparatur und die Werkstatt wird die
              Servicekosten direkt mit Ayvens abrechnen.
            </p>
          </div>
        </div>
      </div>
    );
  }
}
